import React from "react";
import ThankYou from "../components/Home/ThankYou";
import Container from "../components/Layouts/Container";
// import { useLocation } from "react-router-dom";

const ThankYouPage = () => {
  // const location = useLocation();

  // React.useEffect(() => {
  //   return () => {
  //     // This runs only when navigating away from this component
  //     sessionStorage.removeItem("CleaningServicePaymentDoneHome");
  //     sessionStorage.removeItem("CleaningServicePaymentDoneBookNow");
  //   };
  // }, [location.pathname]);
  return (
    <Container>
      <ThankYou />
    </Container>
  );
};

export default ThankYouPage;
